import React from 'react';


class ApmComponent extends React.Component {


	render(){
		const matchGamePlayer = this.props.matchGamePlayer;
		if(matchGamePlayer.apm === undefined || matchGamePlayer.apm === null)
		{
			return null;
		}
		const apmHeading = this.props.apmHeading ? this.props.apmHeading : 'Average APM';
		return (
			<div className="apm_container active">
				<a href="https://www.smashladder.com/blogs/view/26zt/2017-03-21/smash-ladder-dolphin-launcher-stable-beta"
				   target="_blank">
					<span title='Actions Per Minute' className="title">{apmHeading}</span>{' '}
					<span className="apm">{matchGamePlayer.apm}</span>
				</a>
			</div>
		)
	}
}

export {ApmComponent}